module.exports = __webpack_public_path__ + "img/user.9ecfc0b2.png";